import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AuthGuard } from "./core/guard/auth.guard";
import { NoAuthGuard } from "./core/guard/no-auth.guard";
import { UserRoleGuard } from "./core/guard/user-role.guard";
import { AuthLayoutComponent } from "./layout/auth-layout/auth-layout.component";
import { ContentLayoutComponent } from "./layout/content-layout/content-layout.component";
import { NotFoundComponent } from "./page-not-found";

const routes: Routes = [
  {
    path: "",
    redirectTo: "/Auth/Login",
    pathMatch: "full",
  },
  {
    path: "Auth",
    component: AuthLayoutComponent,
    canActivate: [NoAuthGuard],
    loadChildren: () =>
      import("../app/modules/auth/auth.module").then((m) => m.AuthModule),
  },
  {
    path: "",
    component: ContentLayoutComponent,
    canActivate: [AuthGuard],
    canLoad: [UserRoleGuard],
    children: [
      {
        path: "Home",
        loadChildren: () =>
          import("../app/modules/home-page/home-page.module").then(
            (m) => m.HomePageModule
          ),
      },
      {
        path: "OfferPeriod",
        loadChildren: () =>
          import("../app/modules/offer-period/offer-period.module").then(
            (m) => m.OfferPeriodModule
          ),
      },
      {
        path: "InterestPeriod",
        loadChildren: () =>
          import("./modules/interest-periods/interest-period.module").then(
            (m) => m.InterestPeriodModule
          ),
      },
      {
        path: "Import",
        loadChildren: () =>
          import("./modules/import-files/import-files.module").then(
            (m) => m.ImportFilesModule
          ),
      },
      {
        path: "Reminder",
        loadChildren: () =>
          import("./modules/reminder/reminder.module").then(
            (m) => m.ReminderModule
          ),
      },
      {
        path: "Enquiry",
        loadChildren: () =>
          import("./modules/enquiry/enquiry.module").then(
            (m) => m.EnquiryModule
          ),
      },
      {
        path: "Disclaimer",
        loadChildren: () =>
          import("./modules/disclaimer/disclaimer.module").then(
            (m) => m.DisclaimerModule
          ),
      }
    ],
  },
  // Fallback when no prior routes is matched
  // { path: '**', redirectTo: '/Auth/Login', pathMatch: 'full' }
  {
    path: "**",
    // resolve: {
    //   path: PathResolveService
    // },
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
